import axios from 'axios'
import Cookie from 'js-cookie'
import { Toast } from 'mand-mobile'
import store from '@/store'
import en from '@/assets/locales/error-code/en.json'
import id from '@/assets/locales/error-code/id.json'

const Texts = {
  en: en,
  id: id,
}

const http = axios.create({
  baseURL: '/api',
  debug: process.env.NODE_ENV !== 'production',
  headers: {
    'accept-language': 'zh-CN',
    client: 'KREDIT_PINTAR',
    'Cache-Control': 'no-cache',
    'x-source': 'H5',
  },
})

http.interceptors.request.use(
  config => {
    const token = Cookie.get('x-request-token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    if (config.url.startsWith('/invested-payment-api')) {
      config.baseURL = ''
    }
    if (config.url.startsWith('/digitsign/download')) {
      config.responseType = 'blob'
    }
    return config
  }, () => {
  },
)

http.interceptors.response.use(
  res => {
    if (res.headers.Authorization) {
      Cookie.set('x-request-token', res.headers.Authorization)
    }
    if (res.config.url.startsWith('/api/get-signature')) {
      return res
    }
    const vue = window.vue
    const code = res.data.code
    switch (code) {
      // account code
      case 'ACCOUNT_ALREADY_EXISTS':
      case 'ACCOUNT_NOT_EXIST':
      case 'ACCOUNT_ID_EXIST':
      case 'ACCOUNT_LOCKED':
      case 'BAD_CREDENTIAL':
      case 'EMAIL_EXIST':
      case 'INVALID_PHONE_NUMBER':
      case 'INVALID_REQUEST_PARAM':
      case 'INVALID_EMAIL':
      case 'INVALID_PASSWORD':
      case 'UNSUPPORTED_REGISTRY_TYPE':
      case 'UN_EXPECTED_RESPONSE':
      case 'MAX_TRANSFER_AMOUNT_EXCEEDED':
      // sms code // break omitted
      case 'SMS_SEND_ERROR':
      case 'VERIFICATION_REACHED_LIMIT':
      case 'WRONG_VERIFICATION_CODE':
      case 'INVALID_EMAIL_VERIFICATION':
      case 'VERIFICATION_ATTEMPT_LIMIT':
      // file code // break omitted
      case 'FILE_EMPTY':
      case 'FILE_UPLOAD_ERROR':
      case 'FILE_DOWNLOAD_ERROR':
      case 'IMAGE_FORMAT_ERROR':
      case 'IMAGE_INVALID_FORMAT':
      case 'IMAGE_INVALID_SIZE':
      case 'IMAGE_NO_FOUND':
      // anti-fraud // break omitted
      case 'OCR_CHECK_ERROR':
      case 'OCR_NO_RESULT':
      case 'BANK_ERROR':
      case 'BANK_ACCOUNT_INVALID':
      case 'BANK_ACCOUNT_ALREADY_EXISTS':
      case 'BANK_ACCOUNT_CREATE_REACH_LIMIT':
      case 'BANK_ACCOUNT_MISMATCH':
      case 'BANK_ACCOUNT_NOT_VERIFIED':
      case 'BANK_BINDING_EDIT_ERROR':
      case 'ID_INFORMATION_EDIT_ERROR':
      case 'INVALID_ID_CARD_NUM':
      // Events investment // break omitted
      case 'EVENTS_NOT_ALLOWED':
      case 'INVESTING_TIMES_EXCEEDED':
      // Transaction // break omitted
      case 'TOP_UP_ERROR':
      case 'TOP_UP_WRONG_STATE':
      case 'TRANSACTION_STILL_PENDING':
      case 'BALANCE_NOT_ENOUGH':
      case 'BALANCE_NOT_EMPTY':
      case 'TRANSACTION_NOT_FOUNT':
      case 'TRANSACTION_MIN_INVEST':
      case 'TRANSACTION_AMOUNT_ZERO':
      case 'TRANSACTION_AMOUNT_ERROR':
      case 'TRANSACTION_EXPIRE':
      case 'TRIAL_REVENUE_RESTRICTED':
      case 'WITH_DRAW_ERROR':
      case 'WITH_DRAW_MIN_AMOUNT':
      case 'ILLEGAL_REST_BALANCE':
      // System error // break omitted
      case 'ERROR':
      case 'PARAMETER_ERROR':
      case 'NOT_FOUND':
      // redeem error // break omitted
      case 'REDEEM_EXPIRED':
      case 'REDEEM_FAILED':
      case 'FORTUNE_CODE_INVALID':
      case 'FORTUNE_CODE_NOT_FOUND':
      // Coupon related error // break omitted
      case 'COUPON_LIMIT':
      // Authentication error // break omitted
      case 'NO_AUTHORIZATION':
      case 'REGISTER_ERROR':
      case 'API_ACCESS_DENIED': {
        setTimeout(() => {
          Toast.failed(Texts[store.state.locale][code])
        }, 300)
        throw new Error(code)
      }
      case 'MOBILE_EXIST': {
        setTimeout(() => {
          Toast.failed(Texts[store.state.locale][code])
        }, 300)
        break
      }
      case 'LOGIN_FAILED': {
        setTimeout(() => {
          Toast.failed(Texts[store.state.locale][code])
        }, 300)
        throw new Error(code)
      }
      case 'NO_LOGIN': {
        if (vue.$store.state.userInfo.id) {
          vue.$store.dispatch('logout')
        }
        if (window.bridge && window.bridge.logout) {
          window.bridge.logout()
        } else if (vue.$route.path.startsWith('/user')) {
          setTimeout(() => {
            Toast.failed(Texts[store.state.locale][code])
          }, 300)
          vue.$router.push({ name: 'Login' })
        }
        throw new Error(code)
      }
      case 'TRANSACTION_INVESTOR_ERROR': {
        setTimeout(() => {
          Toast.failed(Texts[store.state.locale][code])
        }, 300)
        vue.$router.push({ name: 'SignupResult' })
        throw new Error(code)
      }
      case 'REDEEM_SUCCESSFUL':
      case 'SUCCESS': {
        break
      }
      default: {
      }
    }
    return res
  },
  error => {
    console.log('network error', error)
    return Promise.reject(error)
  },
)

export default http
